import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { CtaRow, GhostCta, PrimaryCta, useLanding } from '@/components/Landing/LandingKit';
import { BILLING, PREMIUM_BILLING } from '@/constants/pricingContent';
import { API_DAILY_LIMIT_PLUS_DISPLAY, API_DAILY_LIMIT_PREMIUM_DISPLAY, PLUS_MONTHLY_CREDITS_DISPLAY, PLUS_PREMIUM_MONTHLY_CREDITS_DISPLAY } from '@/constants/config';
import { ApiBody, ApiSection, ApiSplit, ApiTitle } from './ApiEditorial';

const PLANS = [
  { name: 'Plus', price: BILLING, credits: PLUS_MONTHLY_CREDITS_DISPLAY, requests: API_DAILY_LIMIT_PLUS_DISPLAY },
  { name: 'Plus Premium', price: PREMIUM_BILLING, credits: PLUS_PREMIUM_MONTHLY_CREDITS_DISPLAY, requests: API_DAILY_LIMIT_PREMIUM_DISPLAY },
];
function ApiPricing() {
  const { c, isXS, isCompact } = useLanding();
  return (
    <ApiSection label="API access and pricing">
      <ApiSplit>
        <View style={{ flex: isCompact ? undefined : 0.9, minWidth: 0 }}>
          <ApiTitle>Access and usage.</ApiTitle>
          <ApiBody style={{ marginTop: 20 }}>API access is included with Plus and Plus Premium. Requests draw from your credit balance, with a one-credit minimum per request.</ApiBody>
          <ApiBody style={{ fontSize: 14, lineHeight: 24, marginTop: 16 }}>Chat and text requests are charged at provider cost plus a margin. Media generation uses catalog pricing. Top-up credits never expire.</ApiBody>
        </View>
        <View style={{ flex: isCompact ? undefined : 1.5, minWidth: 0 }}>
          {PLANS.map((plan, index) => (
            <View key={plan.name} style={{ paddingTop: index ? 24 : 0, paddingBottom: 24, borderBottomWidth: 1, borderBottomColor: c.rule }}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', gap: 16 }}>
                <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 21, lineHeight: 28 }}>{plan.name}</Text>
                <Text weight="medium" style={{ color: c.ink, fontSize: 21, lineHeight: 28 }}>${plan.price.annualPerMonth}<Text style={{ color: c.muted, fontSize: 13 }}> / month</Text></Text>
              </View>
              <Text style={{ color: c.muted, fontSize: 13, lineHeight: 22, marginTop: 8 }}>${plan.price.annualTotal} billed annually, or ${plan.price.monthly} billed monthly.</Text>
              <Text style={{ color: c.inkSoft, fontSize: 14, lineHeight: 24, marginTop: 12 }}>{plan.credits} credits / month · {plan.requests} requests / day</Text>
            </View>
          ))}
          <Text style={{ color: c.muted, fontSize: 13, lineHeight: 22, marginTop: 16 }}>Daily request limits apply alongside your available credit balance.</Text>
        </View>
      </ApiSplit>
      <View style={{ flexDirection: isCompact ? 'column' : 'row', alignItems: isCompact ? 'stretch' : 'center', justifyContent: 'space-between', gap: 24, marginTop: 42, paddingTop: 32, borderTopWidth: 1, borderTopColor: c.rule }}>
        <Text weight="medium" style={{ color: c.ink, fontSize: 22, lineHeight: 29, letterSpacing: -0.5 }}>Build something with Gab AI.</Text>
        <CtaRow><PrimaryCta restrained label="Get an API key" href="/signup" full={isXS} /><GhostCta label="Full pricing" href="/pricing" /></CtaRow>
      </View>
    </ApiSection>
  );
}
export default React.memo(ApiPricing);
